<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import "@/units/quill.css";
import "@/units/common.css";
export default {
  name: "app",
  sockets: {
    //查看socket是否渲染成功
    connect() {
      console.log("全局链接成功");
      if (this.isLogin == 0) {
        // console.log(this.isLogin)
        // console.log(localStorage.getItem('userId'))
          this.$socket.emit("login", { role: this.role, userId: localStorage.getItem('userId') });
      }
    },
    disconnect() {
      console.log("断开链接");
    }, 
    //检测socket断开链接
    reconnect() {
      console.log("重新链接");
      // console.log(this.isLogin)
      
    },
    login() {
      console.log("登录");
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    role() {
      return this.$store.state.role;
    },
  },
  watch: {
    isLogin: function (val) {
      //  console.log(val)
    },
    role: function (val) {
      // console.log(val)
    },
    userId: function (val) {
      // console.lo(val)
    },
  },
  mounted() {
    // let isLogin = this.$store.state.isLogin;
    // let role = this.$store.state.role;
    // let userId = this.$store.state.userId;

    let beginTime = 0; //开始时间
    let differTime = 0; //时间差

    window.onunload = function () {
      differTime = new Date().getTime() - beginTime;
      console.log();
      if (differTime <= 5) {
        console.log("这是关闭");
        localStorage.setItem("isLogin", 1);
        localStorage.setItem("role", "");
        localStorage.setItem("username", "");
        localStorage.setItem("icon", "");
        localStorage.setItem("token", "");
        localStorage.setItem("authentation", "");
        localStorage.setItem("taskId", "");
        localStorage.setItem("chapterId", "");
        //退出登录跳到首页
        this.$router.push({ path: "/" });
      } else {
        console.log("这是刷新")
        
      }
    };       
  },
};
</script>

